import { TemporaryDescendant, serializeHTML } from "./htmlHelpers";

const serializeHtmlFromDescendant = (descendant: TemporaryDescendant[]) => {
  return descendant.map((el, idx) => serializeHTML(el, idx));
};

export default serializeHtmlFromDescendant;
